/** Run-workspace tab ids — the detail page's `?tab` search param values.
 *  Work units, lineage (2026-09-14) and the stage timeline (2026-09-15) live
 *  inside Overview; an old `?tab=tree|lineage|timeline` link falls back to the
 *  default via `validateSearch`. `workflow` (2026-10-06) is the Temporal-style
 *  inspector for the run's own workflow. */
export const RUN_DETAIL_TABS = ['overview', 'products', 'workflow'] as const;
export type RunDetailTab = (typeof RUN_DETAIL_TABS)[number];

/** Default tab when `?tab` is absent or invalid. */
export const DEFAULT_RUN_DETAIL_TAB: RunDetailTab = 'overview';
